export default __webpack_public_path__ + "static/media/sharif.059cf623.jpeg";